const metaData = {
  fields: [
    'id',
    'name',
    'created_at',
    'updated_at',
    'created_by',
    'updated_by',
    'description',
    'status',
    'product_id',
    'slot_data',
    'request_type',
    'parent_paper_id',
    { product: ['name', 'product_id', 'test_track_ids'] },
    'paper_setter_id',
    { userByPaperSetter: ['displayName'] },
    'paper_approver_id',
    { userByPaperApprover: ['displayName'] },
    'test_track_id',
    { test_track: ['name', 'test_track_id', 'id', 'grade_ids', 'subject_ids'] },
    'paper_template_id',
    'project_id',
    { project_config: ['id', 'name'] },
    {
      paper_template: [
        'name',
        'id',
        'description',
        'sections',
        'test_track_id',
        {
          paper_template: [
            'name',
            'id',
            'section_id',
            'no_of_questions',
            'mark_per_question',
            'theme_id',
            'sub_theme',
            'report_theme_id',
            'subject_id',
            'topic_id',
            'section_id',
            'question_type_id',
            'blooms_level_id',
            'difficult_level_id',
            'strand_id',
            'competency_id',
            { question_type: ['id', 'name'] },
            { theme: ['id', 'name'] },
            { subject: ['id', 'name'] },
            { topic: ['id', 'name'] },
            { sub_theme: ['id', 'name'] },
            { report_theme: ['id', 'name'] },
            { section: ['id', 'name'] },
          ],
        },
      ],
    },
    'test_event_id',
    {
      test_event: ['id', 'test_event_id', 'name', 'mode_of_exam', 'location', 'slots', 'restrictions', { product: ['name'] }],
    },
    { papers: ['id'] },
  ],
}

export default metaData
